export default __webpack_public_path__ + "static/media/22t.0a5e65dd.jpg";